<template>
    <div>
      <zx-table
        :tableData="tableData"
        :option="table"
        :page="page"
        :searchDesc="searchDesc"
        @searchSubmit="searchSubmit"
        @handleSelectionChange="handleSelectionChange"
        @delBtn="closeBtn"
        @refresh-change="getlist"
        @refreshBtn="refreshBtn"
      />
      <ele-form-dialog
        v-model="formData"
        :formDesc="formDesc"
        :request-fn="handleSubmit"
        :rules="rules"
        labelPosition="left"
        :form-attrs="{ size: 'small' }"
        :dialogAttrs="{
          center: false,
          'destroy-on-close': true,
          'custom-class': 'formD'
        }"
        :visible.sync="dialogFormVisible"
        @request-success="handleSuccess"
        :title="table.title"
      />
    </div>
  </template>
  <script>
  import * as routing from "@/api/routing/link.js"
  import xzTable from "@/components/xz-table.vue";
  export default {
    components: {
      "zx-table": xzTable
    },
    data() {
      return {
        searchDesc: {
          name: {
            label: "名称",
            type: "input"
          },
          type: {
            label: "账号类型",
            type: "select",
            options: [
              {
                text: "商户",
                value: "MERCHANT_ID"
              },
              {
                text: "个人",
                value: "PERSONAL_OPENID"
              }
            ]
        },
        status: {
          label: "状态",
          type: "select",
          options: [
            {
              text: "正常",
              value: "1"
            },
            {
              text: "禁用",
              value: "2"
            }
          ]
        },
        relation_type: {
          label: "与分账方关系",
          type: "select",
          options: [
            {
              text: "门店",
              value:"STORE"
            },
            {
              text: "员工",
              value: "STAFF"
            },
            {
              text: "店主",
              value: "STORE_OWNER"
            },
            {
              text: "合作伙伴",
              value: "PARTNER"
            },
            {
              text: "总部",
              value: "HEADQUARTER"
            },
            {
              text: "品牌方",
              value: "BRAND"
            },
            {
              text: "分销商",
              value: "DISTRIBUTOR"
            },
            {
              text: "用户",
              value: "USER"
            },
            {
              text: "供应商",
              value: "SUPPLIER"
            },
            {
              text: "自定义",
              value: "CUSTOM"
            }
          ]
        }
        },
        formData: {},
        formDesc: {
          type: {
            label: "账号类型",
            type: "select",
            options: [
              {
                text: "商户",
                value: "MERCHANT_ID"
              },
              {
                text: "个人",
                value: "PERSONAL_OPENID"
              }
            ]
          },
          name: {
            label: "接收方名称",
            type: "input"
          },
          is_excess: {
            label: "分账比例",
            type: "input",
            append: "%",
            default: "30",
            tip: "分账比例，填30表示30%，分给分账方的金额为订单金额的30%"
          },
          relation_type: {
            label: "与分账方关系",
            type: "select",
            options: [
              {
                text: "门店",
                value:"STORE"
              },
              {
                text: "员工",
                value: "STAFF"
              },
              {
                text: "店主",
                value: "STORE_OWNER"
              },
              {
                text: "合作伙伴",
                value: "PARTNER"
              },
              {
                text: "总部",
                value: "HEADQUARTER"
              },
              {
                text: "品牌方",
                value: "BRAND"
              },
              {
                text: "分销商",
                value: "DISTRIBUTOR"
              },
              {
                text: "用户",
                value: "USER"
              },
              {
                text: "供应商",
                value: "SUPPLIER"
              },
              {
                text: "自定义",
                value: "CUSTOM"
              }
            ]
          }
        },
        rules: {},
        qrUrl: "",
        dialogVisible: false,
        dialogFormVisible: false,
        page: {
          total: 1,
          pagerCount: 1,
          currentPage: 1,
          pageSize: 25,
          pageSizes: [15, 25, 30, 40, 50, 100],
          layout: "total, sizes, prev, pager, next, jumper",
          background: true
        },
        table: {
          title: "分账接受方",
          // 表格底部按钮
          btnBottom: false,
          // 操作按钮列定位 默认:false;
          fixed: false,
          // 子表格 默认: ; 数据格式:String;<对应子行字段名称>
          children: "children",
          // 多选 默认:false;
          // selection: false,
          // 单选高亮
          current: true,
          //搜索框 默认:false;
          searchBtn: false,
          // 表格高度 默认:100%; 数据格式:Number;
          // height:500,
          // 数边框 默认:false;
          border: false,
          //索引 默认:true;
          index: true,
          // 刷新 默认:true;
          refreshBtn: true,
          // 添加 默认:true;
          addBtn: false,
          // 编辑 默认:true;
          editBtn: false,
          // 删除  默认:true;
          delBtn: true,         
          // 折叠筐 默认:false;
          expand: false,
          column: [
            {
              prop: "name",
              label: "名称",
              type: "input",
              // 1普通用户 2会员用户 3分销商用户
              hide: true
            },
            {
            prop: "type",
            label: "账号类型",
            type: "input",
            show: "tag",
            tagtype: [
              {
                text: "商户",
                value: "MERCHANT_ID",
              },
              {
                text: "个人",
                value: "PERSONAL_OPENID",
                type: "success",
              }
            ],
            hide: true
            },
            {
              prop: "is_excess",
              label: "分账比例%",
              center: true,
            },
            {
              prop: "relation_type",
              label: "与分账方关系",
              type: "select",
              tagtype: [
                {
                  text: "门店",
                  value:"STORE"
                },
                {
                  text: "员工",
                  value: "STAFF"
                },
                {
                  text: "店主",
                  value: "STORE_OWNER"
                },
                {
                  text: "合作伙伴",
                  value: "PARTNER"
                },
                {
                  text: "总部",
                  value: "HEADQUARTER"
                },
                {
                  text: "品牌方",
                  value: "BRAND"
                },
                {
                  text: "分销商",
                  value: "DISTRIBUTOR"
                },
                {
                  text: "用户",
                  value: "USER"
                },
                {
                  text: "供应商",
                  value: "SUPPLIER"
                },
                {
                  text: "自定义",
                  value: "CUSTOM"
                }
              ],
              show: "tag",
            },
            {
              prop: "status",
              label: "用户状态",
              type: "input",
              show: "tag",
              tagtype: [
                {
                  text: "限制使用",
                  value: -1,
                  type: "danger",
                },
                {
                  text: "待注册分账",
                  value: 1,
                  type: "warning",
                },
                {
                  text: "分账用户",
                  value: 2,
                  type: "success",
                }
              ],
              hide: true
            },
            {
              prop: "create_time",
              label: "创建时间"
            }
          ],
          btnList: [
            {
              name: "编辑",
              size: "mini",
              type: "text",
              click: (id, row, index) => {
                this.formData = row;
                this.dialogFormVisible = true;
              }
            }
          ]
        },
        tableData: []
      };
    },
    created() {
      this.getlist();
    },
    mounted() {},
    methods: {
      handleSubmit(form) {
        routing.routingLink.r(form).then(res => {
          this.chushihua("编辑成功");
        });
      },
      chushihua(text) {
        if (text) this.$message.success(text);
        this.formData = {};
        this.dialogFormVisible = false;
        this.getlist();
      },
      // 关闭分账
      closeBtn(form) {
        this.$confirm("此操作将删除删除分账接收方, 是否继续?","提示",{
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          routing.delRoutingLink.r({ id: form.id })
          .then(() => {
            this.$message({
              type: "success",
              message: "操作成功!"
            });
            this.getlist();
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除"
            });
          });
        });
      },
      //   多选
      handleSelectionChange(e) {},
      // 筛选条件
      searchSubmit(e) {
        this.searchData = e;
        if (e) {
          this.page.currentPage = 1;
        }
        this.getlist();
      },
      // 刷新
      refreshBtn(e) {
        this.getlist();
      },
      // 分页器
      refreshChange(e) {
        let that = this;
        setTimeout(() => {
          this.getlist();
        }, 1000);
      },
      getlist(e) {
        let param;
        let that = this;
        if (e) {
          that.page = e;
          param = {
            page: e.currentPage,
            limit: e.pageSize
          };
        } else {
          param = {
            page: this.page.currentPage,
            limit: this.page.pageSize
          };
        }
        if (this.searchData) {
          param = {
            page: this.page.currentPage,
            limit: this.page.pageSize,
            ...this.searchData
          };
        }
        routing.linkNameList.r(param).then(res=>{
          that.tableData = res.list;
          that.page.total = res.total;
          console.log(res);
        })
      }
    }
  };
  </script>
  